import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import { RiExternalLinkLine } from "react-icons/ri"

const mentionsLegales = () => {
  return (
    <Layout>
      <SEO title="Mentions légales" />
      <div className="container py-5">
        <div className="row">
          <div className="col-md-12">
            <h2>Mentions légales</h2>
          </div>
          <div className="col-md-12 mt-5 mb-3">
            <h3>Informations générales</h3>
            <p>
              Ce site est la propriété de Catherine COUTEN E.I. 23, rue des
              jardiniers 60300 Senlis – Tél : 06 09 64 27 92 –
              <a href="mailto:couten.catherine@gmail.com">
                couten.catherine@gmail.com
              </a>
              <br />
              N° SIRET : 52935077900011
              <br />
              Prestataire de formation enregistré sous le numéro 22 60 02604 60
              auprès de la Préfecture de la Région Picardie. Cet enregistrement
              ne vaut pas agrément de l’Etat.
            </p>
            <p>
              Ce site est hébergé par{" "}
              <a
                href="https://www.netlify.com/"
                target="_blank"
                rel="noreferrer"
              >
                Netlify <RiExternalLinkLine />
              </a>
            </p>
            <p>Ce site a fait l’objet d’une déclaration auprès de la CNIL.</p>
            <p>
              Responsable de rédaction et de la publication : Catherine COUTEN
              E.I.
            </p>
            <p>Webdesigner et webmaster : Geoffrey COUTEN</p>

            <h3>Données personnelles</h3>
            <p>
              Les informations recueillies à partir de ce site font l’objet d’un
              traitement informatique destiné exclusivement à Catherine COUTEN
              E.I. pour la finalité suivante : Gestion de la clientèle. Le
              destinataire des données est : Catherine COUTEN E.I..
            </p>
            <p>
              Conformément à la{" "}
              <a
                href="https://www.cnil.fr/fr/loi-78-17-du-6-janvier-1978-modifiee"
                target="_blank"
                rel="noreferrer"
              >
                loi « informatique et libertés » du 6 janvier 1978 modifiée
              </a>
              , vous disposez d’un&nbsp;
              <a
                href="https://www.cnil.fr/fr/le-droit-dacces"
                target="_blank"
                rel="noreferrer"
              >
                droit d’accès
              </a>{" "}
              et{" "}
              <a
                href="https://www.cnil.fr/fr/le-droit-de-rectification"
                target="_blank"
                rel="noreferrer"
              >
                de rectification
              </a>{" "}
              aux informations qui vous concernent. Vous pouvez accéder aux
              informations vous concernant&nbsp;en adressant un mail à{" "}
              <a href="mailto:couten.catherine@gmail.com">
                couten.catherine@gmail.com.{" "}
              </a>
              Vous pouvez également, pour des motifs légitimes,{" "}
              <a
                href="https://www.cnil.fr/fr/le-droit-dopposition"
                target="_blank"
                rel="noreferrer"
              >
                vous opposer&nbsp;au traitement des données vous concernant
              </a>
              . Pour en savoir plus,{" "}
              <a
                href="https://www.cnil.fr/fr/comprendre-vos-droits"
                target="_blank"
                rel="noreferrer"
              >
                consultez&nbsp;vos droits sur le site de la CNIL
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default mentionsLegales
